/**
 * The permissions the bank connection routes declare
 * (`server/internal/bankrec/connection_catalogue.go`, `handler_connections.go`).
 *
 * - `read` — list, get and the health report;
 * - `manage` — create, edit, activate, disable and fetch now;
 * - `test` — run a connection test (records a result, moves no statement).
 */
export const BANK_CONNECTION_PERMISSIONS = {
  read: 'treasury.connection.read',
  manage: 'treasury.connection.manage',
  test: 'treasury.connection.test',
} as const
